module.exports = __webpack_public_path__ + "media/images/flags/16/El-Salvador-6af164f3ed9e2afef2f696e865775885.png";